import Input from "./input"

const Select = {
  sizes: Input.sizes,
  variants: Input.variants,
}

export default Select
